<style scoped>
.canvas-container {
    width: 100%;
}

canvas {
    width: 100%;
    height: 100%;
    display: block;
}
</style>

<template>
    <div class="canvas-container">
        <canvas ref="canvas" width="220" height="220"></canvas>
    </div>
</template>

<script>
export default {
    name: 'zoezi-teamsport-team-logo',

    props: {
        upperColor: {
            type: String
        },
        lowerColor: {
            type: String
        },
        name: {
            type: String
        }
    },

    watch: {
        upperColor: {
            immediate: true,
            handler() {
                this.createLogo();
            }
        },
        lowerColor: {
            immediate: true,
            handler() {
                this.createLogo();
            }
        },
        name: {
            immediate: true,
            handler() {
                this.createLogo();
            }
        }
    },

    methods: {
        createLogo() {
            const canvas = this.$refs.canvas;
            if (!canvas) return
            var ctx = canvas.getContext("2d");
            const extraSpace = 10;

            document.fonts.load('bold 48px Lato').then(() => {
                // Clear the entire canvas
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, 220, 220);
                ctx.translate(extraSpace, extraSpace);

                if (!this.upperColor || !this.lowerColor) return;

                // Draw outer circle with shadow
                ctx.beginPath();
                ctx.arc(100, 100, 95, 0, 2 * Math.PI);
                ctx.fillStyle = 'white';
                ctx.shadowColor = '#999';
                ctx.shadowBlur = 10;
                ctx.shadowOffsetX = 5;
                ctx.shadowOffsetY = 5;
                ctx.fill();

                // Add stroke to the circle for a distinct edge
                ctx.strokeStyle = '#DDD';
                ctx.lineWidth = 2;
                ctx.stroke();

                // Shut off the shadow
                ctx.shadowColor = 'transparent';

                // Draw the upper half circle
                ctx.beginPath();
                ctx.arc(100, 100, 80, Math.PI, 2 * Math.PI);
                ctx.fillStyle = this.upperColor;
                ctx.fill();

                // Draw the lower half circle
                ctx.beginPath();
                ctx.arc(100, 100, 80, 0, Math.PI);
                ctx.fillStyle = this.lowerColor;
                ctx.fill();

                // Draw the white stripe in the middle
                ctx.save();

                // Create a clipping path and draw a wide white stripe
                ctx.beginPath();
                ctx.arc(100, 100, 85, 0, Math.PI * 2);
                ctx.clip();

                ctx.fillStyle = 'white';
                ctx.fillRect(0, 68, 220, 64);

                // Restore the context to remove the clipping path for further drawing
                ctx.restore();

                // Draw the text
                ctx.font = "bold 48px Lato";
                ctx.fillStyle = "black";
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                if (this.name) {
                    // Draw text slightly below the baseline (4px)
                    ctx.fillText(this.name, 100, 104);
                }

                // Reset the transformation matrix
                ctx.setTransform(1, 0, 0, 1, 0, 0);

                // Emit the data URL
                const dataURL = canvas.toDataURL("image/png");
                this.$emit('image-created', dataURL);
            });
        }
    },
    mounted() {
        this.$root.loadFont('Lato', 'Lato', () => this.createLogo())
    }
}
</script>